<template>
	<WizardInputFieldLayout title="Feature name" description="Appears in the list of features in the webapp">
		<template #input>
			<AppTextField v-model="localValue" placeholder="Enter name" outlined />
		</template>
	</WizardInputFieldLayout>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
import WizardInputFieldLayout from '@/components/common/WizardInputFieldLayout.vue';
export default {
	name: 'ToolNameInputField',
	mixins: [VModelMixin],
	components: { WizardInputFieldLayout },
};
</script>

<style lang="scss" scoped></style>
